<template>
    <div class="bg-white rounded shadow">
        <base-form @submit="$emit('submit', form)">
            <header class="flex items-center px-4 py-3 border-b sm:px-6 md:py-4">
                <h1 class="text-lg font-normal">
                    {{ maintenance ? 'Edit' : 'Create' }} a maintenance
                </h1>
            </header>

            <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                <validator-alert :sid="sid" />

                <form-section>
                    <template slot="title">Basics</template>
                    <template slot="description">
                        What needs fixing? The more detailed, the better.
                    </template>

                    <grid-layout>
                        <grid-layout-item>
                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="property"
                            >
                                <template slot="label">Property</template>

                                <input-property
                                    v-model="form.property"
                                    :uuid="maintenance ? maintenance.property.uuid : $route.query.property"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="property"
                                />

                                <template
                                    v-if="!maintenance && form.property === null"
                                    slot="hint"
                                >
                                    Do you need to
                                    <router-link
                                        :to="{
                                            name: $router.fix('dashboard.*.properties.create'),
                                            query: {
                                                then: 'create-maintenance'
                                            }
                                        }"
                                        class="text-blue"
                                    >
                                        create a property
                                    </router-link>
                                    first?
                                </template>
                            </form-item>
                        </grid-layout-item>

                        <grid-layout-item>
                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="title"
                            >
                                <template slot="label">Title</template>

                                <input-text
                                    v-model="form.title"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    placeholder="e.g. Leaking boiler"
                                    name="title"
                                />
                            </form-item>
                        </grid-layout-item>

                        <grid-layout-item>
                            <form-item
                                :sid="sid"
                                name="description"
                            >
                                <template slot="label">Description</template>

                                <input-textarea
                                    v-model="form.description"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="description"
                                    placeholder="e.g. The boiler in the kitchen is leaking water onto the worktop."
                                />

                                <template slot="hint">Tip: provide enough information to enable a contractor to fix the issue.</template>
                            </form-item>
                        </grid-layout-item>
                    </grid-layout>
                </form-section>
            </div>

            <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                <form-section>
                    <template slot="title">Photos</template>
                    <template slot="description">
                        Photos help provide context to your words.
                    </template>

                    <grid-layout>
                        <grid-layout-item>
                            <form-item
                                :sid="sid"
                                name="uploads"
                            >
                                <template slot="label">Photos</template>

                                <input-uploads
                                    v-model="form.uploads"
                                    name="uploads"
                                    :max-files="20"
                                    :sid="sid"
                                />
                            </form-item>
                        </grid-layout-item>
                    </grid-layout>
                </form-section>
            </div>

            <base-form-footer>
                <base-button
                    :is-loading="is_saving"
                    type="submit"
                    class="w-full btn-blue md:w-auto"
                >
                    {{ maintenance ? 'Edit' : 'Create' }} maintenance
                </base-button>
            </base-form-footer>

            <slot
                name="modals"
                :reset="reset"
            />
        </base-form>
    </div>
</template>

<script>
    import _ from 'lodash'
    import InputProperty from './input-property'

    export default {
        components: {
            InputProperty
        },
        props: {
            maintenance: {
                type: Object,
                default: null
            },
            sid: {
                type: String,
                required: true
            },
            isLoading: {
                type: Boolean,
                required: true
            },
            hasLoaded: {
                type: Boolean,
                required: true
            }
        },
        data () {
            return {
                form: {
                    property: null,
                    title: '',
                    description: '',
                    uploads: []
                }
            }
        },
        created () {
            this.reset()
        },
        computed: {
            is_saving () {
                return this.isLoading
            }
        },
        methods: {
            reset (sid = null) {
                if (sid) {
                    this.$validator.reset(sid)
                }

                this.form.title = _.get(this.maintenance, 'title')
                this.form.description = _.get(this.maintenance, 'description')
                this.form.uploads = _.get(this.maintenance, 'files.data', [])
            }
        }
    }
</script>
